import { LOCALE_LSK } from 'app.constants'

// an interface declaration to handle the window.locale type:
declare global {
    interface Window {
        locale: string | undefined
    }
}

export const getLocale = () => {
    let locale = null
    try{
        locale = localStorage.getItem(LOCALE_LSK) ?? null
    }catch(e){
        locale = window.locale ?? null
    }
    return locale
}

export const updateLocale = (locale: string) => {
    try{
        if(locale){
            localStorage.setItem(LOCALE_LSK, locale)
        }else{
            localStorage.removeItem(LOCALE_LSK)
        }
    }catch(e){
        window.locale = locale ?? undefined
    }
}
